import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-video-launch',
  templateUrl: './video-launch.component.html',
  styleUrls: ['./video-launch.component.scss'],
}) 
export class VideoLaunchComponent implements AfterViewInit {
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  private hasVideoStarted = false;

  constructor(private gtmService: GoogleTagManagerService) {}
  ngAfterViewInit(): void {
    const video = this.videoElement.nativeElement;
    video.play().catch((error) => {
      console.error('Error attempting to play video:', error);
    });

    video.addEventListener('play', () => this.onPlay());
    video.addEventListener('ended', () => this.onEnded());
  }

  onPlay() {
    if (!this.hasVideoStarted) {
      this.trackVideoEvent('play');
      this.hasVideoStarted = true; // Mark the video as started
    }
  }

  onEnded() {
    this.trackVideoEvent('ended');
    this.hasVideoStarted = false; // Reset for possible future plays
  }
  trackVideoEvent(action: string) {
    const gtmTag = {
      event: 'Customer_video_views',
      event_category: 'Video',
      event_label: 'Unibuild Launch Video',
      event_action: action,
      value_played: action === 'ended' ? 'ended' : 'play',
    };
    this.gtmService.pushTag(gtmTag);
  }
}
